module.exports = __webpack_public_path__ + "img/Maddle.d5478e70.png";